export const kintoneErrorMessage = {//設定項目に紐づかないkintoneの設定関係のエラーメッセージ
    failedToIssueToken: 'kintoneとの連携に失敗しました。ネットワーク状況をご確認ください',
}